import LPFooterNav from './LPFooterNav'

export default LPFooterNav
